import { Component, Input } from '@angular/core';
import { PreorderArticle } from 'app/b2b-order/types/preorder';
import { ReorderArticle } from 'app/b2b-order/types/reorder';

@Component({
    selector: 'fc-product-price-details',
    templateUrl: './price-details.component.html',
    styleUrls: ['./price-details.component.less'],
    standalone: false
})
export class ProductPriceDetailsComponent {
    @Input() article: ReorderArticle | PreorderArticle;
}
